import { turnoverSchema } from '~/components/shared/TurnoverSelect/TurnoverSelect';
import { companySearchSchema } from './components/CompanySearch';
import { z } from '@qred/components-library';

export const companySelectorSchema = z.object({
  ...companySearchSchema.shape,
  ...turnoverSchema.shape,
});

export type CompanySelectorForm = z.infer<typeof companySelectorSchema>;
